export default __webpack_public_path__ + "static/media/docker.f51806fc.jpg";